import React, { useCallback } from 'react'

type Props = {
  onSelect: (e: React.SyntheticEvent) => void
  className?: string
  testId?: string
  onClose?: () => void
}

export const DropDownOption = ({
  onSelect,
  className,
  testId,
  onClose,
  children
}: React.PropsWithChildren<Props>) => {
  const handleKeydown = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.code === 'Space' || e.code === 'Enter') {
        e.stopPropagation()
        e.preventDefault()
        onSelect(e)
        return
      }
      if (e.code === 'Escape') {
        e.stopPropagation()
        e.preventDefault()
        onClose?.()
        return
      }
      if (e.code === 'Tab') {
        // Let native Tab behavior proceed after closing
        onClose?.()
        return
      }
      if (e.code === 'ArrowUp' || e.code === 'ArrowDown') {
        e.preventDefault()
        e.stopPropagation()
        const target = e.target as HTMLElement
        const sibling =
          e.code === 'ArrowUp'
            ? (target.previousElementSibling as HTMLElement)
            : (target.nextElementSibling as HTMLElement)
        sibling?.focus()
      }
    },
    [onSelect, onClose]
  )

  return (
    <div
      className={className}
      tabIndex={0}
      role='option'
      onClick={(e) => {
        onSelect(e)
      }}
      onKeyDown={handleKeydown}
      data-testid={testId ?? 'dropdown-option'}
    >
      {children}
    </div>
  )
}
